import { FETCH_ABOUTINFO } from "../actions/WordPressApiAction";

const initialFetchReducer = [
  {
    title: "",
    tab_list: [],
  },
];

export default function fetchAboutInfoReducer(
  state = initialFetchReducer,
  action
) {
  switch (action.type) {
    case FETCH_ABOUTINFO:
      return action.aboutInfo;
    default:
      return state;
  }
}
